<template>
  <mdb-container class="text-left">
    <mdb-btn @click="doCancel" icon="arrow-left" size="sm" rounded>
      Back to Event
    </mdb-btn>
    <mdb-card class="mb-4">
      <mdb-card-header class="secondary-color">
        <h4>Existing Cross Posts</h4>
      </mdb-card-header>
      <mdb-card-body class="text-left" v-if="crossPosted && crossPosted.length > 0">
        <mdb-list-group>
          <mdb-list-group-item v-for="c in crossPosted" :key="c.groupId">
            {{ c.groupName }}
            <mdb-btn icon="trash" size="sm" tag="a" floating color="danger" @click="deleteCrossPost(c)"/>
          </mdb-list-group-item>
        </mdb-list-group>
      </mdb-card-body>
      <mdb-card-body class="text-left" v-if="!crossPosted || crossPosted.length == 0">
        This event has not been cross posted to any other groups.
      </mdb-card-body>

    </mdb-card>
    <mdb-card class="mb-4">
      <mdb-card-header>
        <h4>Cross Post Candidates</h4>
      </mdb-card-header>
      <mdb-card-body class="text-left" v-if="candidates && candidates.length > 0">
        <mdb-list-group>
          <mdb-list-group-item class="secondary-color list-group-item" >
            Group
            <span class="gp-tools-right">
              <mdb-btn icon="check" v-if="candidates.length>0" rounded size="sm" @click="selectAll()">
                All
              </mdb-btn>
              <mdb-btn icon="minus-circle" v-if="candidates.length>0" rounded size="sm" @click="deselectAll()">
                None
              </mdb-btn>
            </span>
          </mdb-list-group-item>
          <mdb-list-group-item v-for="c in candidates" :key="c.groupId">
            {{ c.groupName }}
            <mdb-input :disabled="!maySelect(c)" :id="'checkbox-'+c.groupId" v-model="c.selected" type="checkbox"/>
          </mdb-list-group-item>
        </mdb-list-group>
      </mdb-card-body>
      <mdb-card-body class="text-left" v-if="!candidates || candidates.length == 0">
        You don't belong to any other groups where you are allowed to post events.
      </mdb-card-body>

      <mdb-card-footer v-if="candidates.length > 0">
        <mdb-btn :disabled="!candidatesSelected" @click="selectCandidates" icon="check">Cross Post to Selected Groups
        </mdb-btn>
        <mdb-btn @click="doCancel" icon="arrow-left">
          Back to Event
        </mdb-btn>
      </mdb-card-footer>
    </mdb-card>

    <yes-no-modal @yes="doDelete" @no="deleteModal = false" v-if="deleteModal"/>

  </mdb-container>

</template>

<script>
import api from '../../services/groupsPlaceApi.js';

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem
} from 'mdbvue';

import YesNoModal from "../common/YesNoModal";

export default {
  name: 'Event-Cross-Post',
  components: {
    mdbBtn,
    mdbIcon,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardFooter,
    mdbContainer,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    YesNoModal
  },
  props: {
    event: {
      type: Object,
      default: null
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    currentGroup() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    },
    candidatesSelected() {
      let selected = false
      if (!this.candidates) return false
      for (let c of this.candidates) {
        if (c.selected) selected = true
      }
      return selected
    },
  },
  data() {
    return {
      crossPosted: [],
      candidates: [],
      deleteCandidate: null,
      deleteModal: false

    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true);
    api.get("/event/crossPostList/" + this.event.eventId).then(
      (results) => {
        this.crossPosted = results.data.crossPosted
        this.candidates = results.data.candidates
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 10000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    selectAll() {
      for (let c of this.candidates) {
        if (this.maySelect(c)) {
          c.selected = true
        }
      }
    },
    deselectAll() {
      for (let c of this.candidates) {
        c.selected = false
      }
    },
    deleteCrossPost(cp) {
      this.deleteCandidate = cp
      this.deleteModal = true
    },
    doDelete() {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true);
      api.delete("/event/crossPostDelete/" + this.deleteCandidate.id).then(
        () => {
          let loc = this.crossPosted.indexOf(this.deleteCandidate)
          if (loc > -1) this.crossPosted.splice(loc, 1)
          this.deleteCandidate = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    maySelect(candidate) {
      let allow = true
      if (!this.crossPosted) return true
      for (let cp of this.crossPosted) {
        if (cp.groupId == candidate.groupId) allow = false
      }
      return allow
    },
    selectCandidates() {
      this.$store.dispatch("setExecuting", true);
      api.post("/event/crossPost/" + this.event.eventId, this.candidates).then(
        (results) => {
          this.crossPosted = results.data.crossPosted
          this.candidates = results.data.candidates
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doCancel() {
      this.$emit("cancelDetails")
    }
  }
}
;
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
